import React from "react";
import {store} from '@redux/store';
import actions from '@redux/EditableTable/actions';
import _ from 'lodash';
import TextArea from "antd/es/input/TextArea";
import moment from "moment";
import { Tooltip } from "antd";
import CompanyLookup from "@containers/Lookup/CompanyLookup";
import {TwoDecimalFormat} from "@components/Format";
import { US_REGIONS } from "@/constants/stateRegionMapping";
import FacilityLink from "@containers/management/Facility/FacilityLink";
import FacilityExpandLink from "@containers/management/Facility/FacilityExpandLink";

const company_items = store.getState().Auth.company;

export const FacilityProps = {
    title: 'Facility',
    name: 'facility',
    description: ''
}


export const FacilityColumns =()=> {
    return [
        {
            title: 'key',
            dataIndex: 'id',
            key: 'id',
            editable: false,
            search: false,
            importIngore: true,
            hideInTable: true,
            width: '4%'
        },
        {
            title: 'Latitude',
            dataIndex: 'latitude',
            key: 'latitude',
            hideInTable: true,
        },
        {
            title: 'Longitude',
            dataIndex: 'longitude',
            key: 'longitude',
            hideInTable: true,
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            search: false,
            edit: true,
            width: 300,
            sorter: (a, b) => a.name?.localeCompare(b.name),
            ellipsis: {
                showTitle: false,
            },
            formItemProps: {
                rules: [
                    {
                        required: true,
                        message: 'required',
                    },
                ],
            },
            renderFormItem: () => <TextArea rows={1}/>,
            render: (text, record, _, action) => (
                <Tooltip placement="topLeft" title={text}>
                    <FacilityLink id={record.id} text={text} action={action} />
                </Tooltip>
            )
        },
        {
            title: 'Company',
            dataIndex: 'company',
            key: 'company',
            edit: true,
            required: true,
            search: false,
            hideInTable: true,
            type: 'Lookup',
            width: '150px',
            render: (text, row) => {
                return <>{_.get(row, 'company_name.name')}</>
            },
            renderFormItem: () => <CompanyLookup/>
        },
        {
            title: 'Company',
            dataIndex: 'company_name',

            key: 'company',
            edit: true,
            required: true,
            search: false,
            type: 'Lookup',
            width: '150px',
            hideInTable: window.innerWidth < 760,
            render: (text, row) => {
                const companyName = _.get(row, 'company_name');
                return (
                    <Tooltip placement="topLeft" title={companyName}>
                        <>{companyName}</>
                    </Tooltip>
                );
            },
            renderFormItem: (_, {isEditable}) => {
                let record = _.entity.company_name ? _.entity.company_name : '';
                return <CompanyLookup record={record}/>
            },
        },
        {
            title: 'Category',
            dataIndex: 'facility_category_name',
            key: 'facility_category_name',
            search: false,
            width: '150px',
            hideInTable: window.innerWidth < 760,
        },
        {
            title: 'Climate Zone',
            dataIndex: 'climate_zone',
            key: 'climate_zone',
            edit: true,
            required: false,
            search: false,
            width: 150,
            hideInTable: window.innerWidth < 760,
            valueType: 'select',
            valueEnum: {
                '1': { text: '1' },
                '2': { text: '2' },
                '3': { text: '3' },
                '4': { text: '4' },
                '5': { text: '5' },
                '6': { text: '6' },
                '7': { text: '7' },
                '8': { text: '8' },
            },
        },
        {
            title: 'Region',
            dataIndex: 'region',
            key: 'region',
            edit: true,
            required: false,
            search: false,
            width: 150,
            hideInTable: window.innerWidth < 760,
            valueType: 'select',
            valueEnum: {
                [US_REGIONS.PACIFIC]: { text: US_REGIONS.PACIFIC },
                [US_REGIONS.ROCKY_MOUNTAINS]: { text: US_REGIONS.ROCKY_MOUNTAINS },
                [US_REGIONS.SOUTHWEST]: { text: US_REGIONS.SOUTHWEST },
                [US_REGIONS.MIDWEST]: { text: US_REGIONS.MIDWEST },
                [US_REGIONS.SOUTHEAST]: { text: US_REGIONS.SOUTHEAST },
                [US_REGIONS.NORTHEAST]: { text: US_REGIONS.NORTHEAST },
                [US_REGIONS.NONCONTIGUOUS]: { text: US_REGIONS.NONCONTIGUOUS },
            },
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
            edit: true,
            required: true,
            search: false,
            width: '250px',
            hideInTable: window.innerWidth < 760,
            render: (text, row) => {
                const address = row.address;
                return (
                    <Tooltip placement="topLeft" title={address}>
                        <>{address}</>
                    </Tooltip>
                );
            },
        },
        {
            title: 'City',
            dataIndex: 'city',
            key: 'city',
            edit: true,
            required: false,
            search: false,
            width: '150px',
            hideInTable: window.innerWidth < 760,
        },
        {
            title: 'State',
            dataIndex: 'state',
            key: 'state',
            edit: true,
            required: false,
            search: false,
            width: '150px',
            hideInTable: window.innerWidth < 760,
        },
        {
            title: 'Country',
            dataIndex: 'country',
            key: 'country',
            edit: true,
            required: false,
            search: false,
            width: '150px',
            hideInTable: window.innerWidth < 760,
        },
        {
            title: 'Contact Name',
            dataIndex: 'contact_name',
            key: 'contact_name',
            edit: true,
            required: false,
            search: false,
            width: '150px',
            hideInTable: window.innerWidth < 760,
            renderFormItem: () => <TextArea rows={1}/>,
        },
        {
            title: 'Contact Email',
            dataIndex: 'contact_email',
            key: 'contact_email',
            edit: true,
            required: false,
            search: false,
            width: '180px',
            hideInTable: window.innerWidth < 760,
            renderFormItem: () => <TextArea rows={1}/>,
        },
        {
            title: 'Contact Phone',
            dataIndex: 'contact_phone',
            key: 'contact_phone',
            edit: true,
            required: false,
            search: false,
            width: '150px',
            hideInTable: window.innerWidth < 760,
            renderFormItem: () => <TextArea rows={1}/>,
        },

        // {
        //     title: 'Tag',
        //     dataIndex: 'tag',
        //     key: 'tag',
        //     search: false,
        //     editable: false,
        //     render: (text, record) => {
        //         console.log('tag text:', text, typeof (text))
        //         let tags = (text && text !== '-' && typeof (text) !== 'object') ? JSON.parse(text) : [];
        //         console.log('tags', tags)
        //         return <TagInputWrapper>
        //             <div className="AddAndDelete">
        //                 <div className="main">
        //                     <DraggableArea
        //                         tags={tags}
        //                         render={({tag, index}) => (
        //                             <div className="tag">
        //                                 <img
        //                                     className="delete"
        //                                     srcSet={`${deleteBtn2x} 2x`}
        //                                 />
        //                                 {tag.content}
        //                             </div>
        //                         )}
        //                     />
        //                 </div>
        //             </div>
        //         </TagInputWrapper>
        //     }
        // },
        {
            title: 'Latitude',
            dataIndex: 'latitude',
            key: 'latitude',
            edit: true,
            required: true,
            search: false,
            hideInTable: window.innerWidth < 760,
            align: 'right', // 数字列右对齐
            render: (text, record, _, action) => (
                <>{TwoDecimalFormat(text)}</>
            )
        },
        {
            title: 'Longitude',
            dataIndex: 'longitude',
            key: 'longitude',
            edit: true,
            required: true,
            search: false,
            hideInTable: window.innerWidth < 760,
            align: 'right', // 数字列右对齐
            render: (text, record, _, action) => (
                <>{TwoDecimalFormat(text)}</>
            )
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            edit: true,
            required: true,
            search: false,
            hideInTable: window.innerWidth < 760,
            renderFormItem: () => <TextArea rows={1}/>,
        },
        {
            title: 'Year',
            dataIndex: 'year',
            key: 'year',
            edit: true,
            required: true,
            search: false,
            hideInTable: window.innerWidth < 760,
            align: 'right', // 数字列右对齐
        },
        {
            title: 'Area',
            dataIndex: 'area',
            key: 'area',
            edit: true,
            required: true,
            search: false,
            hideInTable: window.innerWidth < 760,
            align: 'right', // 数字列右对齐
        },
        {
            title: 'Modified Date',
            dataIndex: 'modified_date',
            key: 'modified_date',
            editable: false,
            importIngore: true,
            width: '150px',
            hideInTable: window.innerWidth < 760,
            align: 'right', // 时间列右对齐
            sorter: true,
            render: (text, record) => (
                moment(record.modified_date).format('YYYY-MM-DD')
            )
        },
        {
            title: '',
            valueType: 'option',
            width: '6rem',
            importIngore: true,
            render: (text, record, _, action) => (
                <div className={'space-around'}>
                    {/*<a*/}
                    {/*    key="editable"*/}
                    {/*    onClick={() => (action?.startEditable?.(record.id))}*/}
                    {/*>*/}
                    {/*    <i className="fas fa-edit text-lg"></i>*/}
                    {/*</a>*/}
                    <FacilityExpandLink id={record.id} action={action} />
                </div>
            ),
        },


    ];
}

